<template>
  <div id="edit-itemServices">
    <form
      id="items-services-edit-form"
      data-abide
      novalidate
    >
      <div
        v-for="(section, secIndex) in sections"
        :key="secIndex"
      >
        <div class="row">
          <input
            v-show="section.forReference"
            id="tender-section-optional-items"
            v-hkldinput
            type="checkbox"
            class="section-optional-items-checkbox"
            name="tender-section-optional-items"
            :checked="section.checked"
            @change="event => isAddendum
              ? addendumToggleSecForRef(section, secIndex, 'checked', event.target.checked)
              : onOptionalChange(secIndex, 'checked', event.target.checked)"
          >
          <div
            v-if="section.forReference"
            :id="addId('tender.section.title', secIndex)"
            class="title"
            :class="highlightDeleteChange(section.addendumLabel)"
          >
            {{ section.title }}
          </div>
          <input
            v-else
            :id="addId('tender.section.title', secIndex)"
            type="text"
            :placeholder="$t('tender.section.title')"
            :class="highlightDeleteChange(section.addendumLabel)"
            :disabled="disabledDeletedItem(section.addendumLabel)"
            :value="section.title"
            @change="event => onSectionChange(secIndex, 'title', event.target.value, section.addendumLabel)"
          >
          <dotted-dropdown
            v-show="!section.forReference || section.checked"
            :id="addId('section-actions-dropdown', secIndex)"
          >
            <li
              v-for="item in filterItemActions(section.addendumLabel, section.forReference ? sectionForReferActions : sectionActions, secIndex)"
              :key="addId('section.action', secIndex, item.action)"
              :class="highlightDeleteActions(item.action, section.addendumLabel)"
            >
              <a
                :id="addId('section.action', secIndex, item.action)"
                @click="handleActions(section, item.action, secIndex, -1, secIndex)"
              >
                {{ item.name }}
              </a>
            </li>
          </dotted-dropdown>
        </div>

        <div v-if="section.sectionDesc !== undefined && section.sectionDesc !== null">
          <div
            v-if="section.forReference"
            :id="addId('tender.section.sectionDesc', secIndex)"
            class="description"
            :class="highlightDeleteChange(section.addendumLabel)"
          >
            {{ section.sectionDesc }}
          </div>
          <textarea
            v-else
            :id="addId('tender.section.sectionDesc', secIndex)"
            v-autosize
            type="text"
            :placeholder="$t('tender.section.description')"
            :class="highlightDeleteChange(section.addendumLabel)"
            :disabled="disabledDeletedItem(section.addendumLabel)"
            class="autosize"
            :value="section.sectionDesc"
            @change="event => onSectionChange(secIndex, 'sectionDesc', event.target.value)"
          />
        </div>
        <!-- For reference section shows when section is checked when is not addeundum, or not checked but line items has been deleted/updated when addendum -->
        <div
          v-show="!section.forReference
            || section.checked
            || ((deep(section, 'lineItems.length') > 1 || (deep(section, ['lineItems', 0, 'addendumLabel']) && deep(section, ['lineItems', 0, 'addendumLabel']) !== addendumChangeType.pending.added)) && isAddendum)"
        >
          <table>
            <thead>
              <th class="number">
                #
              </th>
              <th style="padding-left: 0;">
                {{ $t('tender.section.descOfWork') }}
              </th>
              <th class="qty-text">
                {{ $t('tender.section.qty') }}
              </th>
              <th class="unit-text">
                {{ $t('tender.section.unit') }}
              </th>
            </thead>
            <tbody>
              <template v-for="(line, lineIndex) in section.lineItems">
                <tr
                  :key="lineIndex"
                  class="set-border-top"
                  :class="highlightDeleteChange(section.addendumLabel, line.addendumLabel)"
                  @paste="e => onRowPaste(e, section, secIndex)"
                >
                  <td class="number">
                    {{ line.itemNo }}
                  </td>
                  <td style="padding-top: 0; width: 60%;">
                    <textarea
                      :id="addId('line.desc', secIndex, lineIndex)"
                      v-autosize
                      class="autosize desc-work"
                      :placeholder="$t('tender.section.description')"
                      type="text"
                      :disabled="disabledDeletedItem(section.addendumLabel, line.addendumLabel)"
                      :value="line.itemDesc"
                      :required="section.checked || !section.forReference"
                      @change="event => onLineChange(secIndex, lineIndex, 'itemDesc', event.target.value, line.addendumLabel)"
                    />
                  </td>
                  <td style="width: 10%;">
                    <input
                      :id="addId('line.qty', secIndex, lineIndex)"
                      v-fusioninputcheck="{
                        type: 'decimal',
                        pattern: (val) => (Number(val) || 0) > 0,
                        required: (section.checked || !section.forReference) && !disabledDeletedItem(section.addendumLabel, line.addendumLabel)
                      }"
                      class="qty-input"
                      type="text"
                      :disabled="disabledDeletedItem(section.addendumLabel, line.addendumLabel)"
                      :value="line.itemQty"
                      @change="event => onLineChange(secIndex, lineIndex, 'itemQty', event.target.value, line.addendumLabel)"
                    >
                  </td>
                  <td
                    :id="addId('line.unit', secIndex, lineIndex)"
                    class="row"
                    style="padding-right: 0;"
                  >
                    <HKLSelect
                      class="small-8 medium-8 large-8 columns"
                      :value="line.itemUnit || undefined"
                      :options="unitHklOptions"
                      :disabled="disabledDeletedItem(section.addendumLabel, line.addendumLabel)"
                      :showSearch="true"
                      placeholder=""
                      @change="value => onLineChange(secIndex, lineIndex, 'itemUnit', value || '')"
                    />
                    <dotted-dropdown
                      :id="addId('line-actions-dropdown', secIndex, lineIndex)"
                      class="small-2 medium-2 large-2 columns"
                      style="padding: 0 0;"
                    >
                      <template v-for="item in filterItemActions(line.addendumLabel, lineActions, secIndex, lineIndex)">
                        <li
                          :key="addId('line.action', secIndex, lineIndex, item.action)"
                          :class="disableActions(item.action, section.addendumLabel, line.addendumLabel)"
                        >
                          <a
                            :id="addId('line.action', secIndex, lineIndex, item.action)"
                            @click="handleActions(line, item.action, secIndex, lineIndex)"
                          >
                            {{ item.name }}
                          </a>
                        </li>
                      </template>
                    </dotted-dropdown>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <hr
          v-if="(secIndex + 1) !== sections.length"
          class="section-border-hr"
        >
      </div>
    </form>
    <div>
      <hr class="section-border-hr">
      <div class="row">
        <input
          class="section-optional-items-checkbox"
          type="checkbox"
          :checked="allowServiceAddOthers"
          @change="event => updateServiceAddOthers(event.target.checked)"
        >
        <div
          class="title"
          :class="highlightAllowServiceAddOthers"
        >
          {{ $t('tender.section.unExternalOthers') }}
        </div>
      </div>
    </div>
    <div
      id="deleteModal"
      ref="deleteModal"
      class="reveal"
      data-reveal
    >
      <div class="tender-confirm clearfix modal-container">
        <p class="confirm-header">
          {{ $t('tender.section.deleteWarning', [deleteActionName]) }}
        </p>
        <div class="row align-right nav_btn">
          <button
            type="button"
            class="btn btn--darkblue"
            @click="closeAlertModal()"
          >
            {{ $t('no') }}
          </button>
          <button
            type="button"
            class="btn btn--orange"
            @click="confirmDelete()"
          >
            {{ $t('yes') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'
import HKLSelect from '@/controls/Select/HKLSelect.vue'
import DottedDropdown from '@/controls/DottedDropdown'
import { mapState, mapMutations, mapGetters } from 'vuex'
import types from '@/store/mutation-types'
import { addendumChangeType } from '@/utils/locale'
import { mergePasteData } from '@/utils/clipboard'
import { nonNumericCharsInCurrency } from '@/utils/regex'
import { getHighlightAllowServiceAddOthers } from '@/utils/tenderUtils'
import { TENDER_UNITS } from '@/api/tenders/consts'
import { utils as formUtils } from '@/plugin/InputChange'
import { fusionInputCheckUtil } from '@/plugin/FusionInputCheck'

export default {
  components: {
    HKLSelect,
    DottedDropdown,
  },

  props: {
    lockItems: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      sectionForReferActions: [
        { name: 'Add Line', action: 'addLine' },
        { name: 'Undo', action: 'undoDeleteSection' },
      ],
      sectionActions: [
        { name: 'Add Section', action: 'addSection' },
        { name: 'Add Section Description', action: 'addSectionDesc' },
        { name: 'Add Line', action: 'addLine' },
        { name: 'Delete Section', action: 'deleteSection' },
        { name: 'Undo', action: 'undoDeleteSection' },
      ],
      lineActions: [
        { name: 'Add Line', action: 'addLine' },
        { name: 'Add Section', action: 'addSection' },
        { name: 'Delete Line', action: 'deleteLine' },
        { name: 'Undo', action: 'undoDeleteLine' },
      ],
      units: TENDER_UNITS,
      defaultUnit: 'Lot',

      serviceStr: 'service',
      lineItemsStr: 'lineItems',
      optionsStr: 'options',
      itemsMarkedAsRemoved: {},
      labelsMarkedAsRemoved: {},
      deleteActionName: '',
      deep,
      addendumChangeType,
    }
  },

  computed: {
    ...mapState('tenders', {
      sections (state) {
        return state.currentTender.service
      },
      addendumClassName (state) {
        return state.addendumClassName
      },
    }),
    ...mapGetters('tenders', [
      'isAddendum',
      'currentTender',
    ]),
    allowServiceAddOthers () {
      return lodash.get(this.currentTender, 'general.allowServiceAddOthers') || false
    },
    highlightAllowServiceAddOthers () {
      return getHighlightAllowServiceAddOthers({
        isAddendum: this.isAddendum,
        currentTender: this.currentTender,
      })
    },
    unitHklOptions () {
      return this.units.map((value) => ({
        name: value,
        value,
      }))
    },
  },
  watch: {
    sections () {
      this.addSectionAsNeed()
    },
  },
  mounted () {
    this.addSectionAsNeed()
  },
  destroyed () {
    if (this.deleteModal) {
      this.deleteModal.destroy()
      delete this.deleteModal
      $('#deleteModal').remove()
    }
  },
  methods: {
    ...mapMutations('tenders', {
      updateSection: types.TENDER_UPDATE_PATH_FIELD,
      updateTenderField: types.TENDER_UPDATE_FIELD,
    }),

    async init (item, secIndex, lineIndex, optIndex) {
      this.selectedLineIndex = this.selectedOptIndex = null
      if (!this.deleteModal) {
        this.deleteModal = await new Foundation.Reveal($('#deleteModal'), {
          closeOnEsc: false,
          closeOnClick: false,
        })
      }
      this.selectedItem = item
      this.selectedSecIndex = secIndex
      this.selectedLineIndex = lineIndex
      this.selectedOptIndex = optIndex
      this.openAlertModal()
    },
    openAlertModal () {
      this.deleteModal.open()
    },
    closeAlertModal () {
      this.deleteModal.close()
    },
    async confirmDelete () {
      switch (this.actionName) {
        case 'deleteSection':
          this.deleteSection(this.selectedItem, this.selectedSecIndex)
          break
        case 'deleteLine':
          this.deleteLine(this.selectedItem, this.selectedSecIndex, this.selectedLineIndex)
          break
        default:
      }
      this.closeAlertModal()
    },
    updateServiceAddOthers (checked) {
      this.updateTenderField({
        sectionName: 'general',
        fieldName: 'allowServiceAddOthers',
        newValue: checked,
      })
    },

    addId (name, ...args) {
      let id = name
      args.forEach((arg) => {
        id = `${id}_${arg}`
      })
      return id
    },
    getSectionByIndex (secIndex) {
      return JSON.parse(JSON.stringify(this.sections[secIndex]))
    },
    getLineItemByIndex (secIndex, lineIndex) {
      const section = this.getSectionByIndex(secIndex)
      return section.lineItems[lineIndex]
    },

    getSectionFieldPath (secIndex, fieldName) {
      const path = [this.serviceStr, secIndex]
      return (fieldName !== null) ? [...path, fieldName] : path
    },
    getLineItemFieldPath (secIndex, lineIndex) {
      const path = this.getSectionFieldPath(secIndex, this.lineItemsStr)
      return (lineIndex !== null) ? [...path, lineIndex] : path
    },
    getOptionFieldPath (secIndex, lineIndex, optionIndex) {
      const path = [...this.getLineItemFieldPath(secIndex, lineIndex), this.optionsStr]
      return (optionIndex !== null) ? [...path, optionIndex] : path
    },

    updateChangedLabelForAddendum (itemPath, updatedLabel) {
      this.updateSection({
        path: [...itemPath, 'addendumLabel'],
        newValue: updatedLabel,
      })
    },
    updateLabelForSection (secIndex, updatedLabel) {
      const sectionPath = this.getSectionFieldPath(secIndex, null)
      this.updateChangedLabelForAddendum(sectionPath, updatedLabel)
    },
    updateLabelForLine (secIndex, lineIndex, updatedLabel) {
      const linePath = this.getLineItemFieldPath(secIndex, lineIndex)
      this.updateChangedLabelForAddendum(linePath, updatedLabel)
    },

    onOptionalChange (secIndex, fieldName, newValue) {
      this.updateSection({ path: this.getSectionFieldPath(secIndex, fieldName), newValue })
    },

    onSectionChange (secIndex, fieldName, newValue, addendumLabel) {
      const value = newValue.trim()
      formUtils.setDirty()
      if (this.isAddendum && addendumLabel !== addendumChangeType.pending.added) {
        this.updateLabelForSection(secIndex, addendumChangeType.pending.updated)
      }

      this.updateSection({ path: this.getSectionFieldPath(secIndex, fieldName), newValue: value })
    },

    onLineChange (secIndex, lineIndex, fieldName, newValue, addendumLabel) {
      const value = newValue.trim()
      formUtils.setDirty()
      const lineItemPath = this.getLineItemFieldPath(secIndex, lineIndex)
      const path = [...lineItemPath, fieldName]
      this.updateSection({ path, newValue: value })
      if (this.isAddendum && addendumLabel !== addendumChangeType.pending.added) {
        this.updateLabelForLine(secIndex, lineIndex, addendumChangeType.pending.updated)
      }
    },

    handleActions (item, actionName, secIndex, lineIndex, optIndex) {
      if (!actionName) {
        return
      }
      formUtils.setDirty()
      this.actionName = actionName
      switch (actionName) {
        case 'addSection':
          this.addSection(false, secIndex)
          break
        case 'addSectionDesc':
          this.addSectionDesc(item, secIndex)
          break
        case 'deleteSection':
          this.init(item, secIndex)
          this.deleteActionName = 'Section'
          break
        case 'addLine':
          this.addLine(secIndex, lineIndex)
          break
        case 'deleteLine':
          this.init(item, secIndex, lineIndex)
          this.deleteActionName = 'Line'
          break
        case 'addOption':
          this.addOption(secIndex, lineIndex)
          break
        case 'deleteOption':
          this.init(item, secIndex, lineIndex, optIndex)
          this.deleteActionName = 'Option'
          break
        case 'undoDeleteSection':
          this.undoDelete(secIndex)
          break
        case 'undoDeleteLine':
          this.undoDelete(secIndex, lineIndex)
          break
        case 'undoDeleteOption':
          this.undoDelete(secIndex, lineIndex, optIndex)
          break
        default:
      }
    },

    getItemKey (...indices) {
      return indices.join(',')
    },

    filterItemActions (addendumLabel = '', actions, ...indices) {
      const key = this.getItemKey(indices)
      return actions.filter((action) => {
        if (action.name.includes('Delete')) {
          return !(this.itemsMarkedAsRemoved[key] || addendumLabel === addendumChangeType.pending.removed) &&
            (addendumLabel !== addendumChangeType.removed)
        }
        if (action.name === 'Undo') return this.itemsMarkedAsRemoved[key] || addendumLabel === addendumChangeType.pending.removed
        if (action.name === 'Add Section') return !this.sections[indices[0]].forReference
        if (action.name === 'Add Section Description') return !('sectionDesc' in this.sections[indices[0]])
        if (action.name === 'Delete Section Description') return ('sectionDesc' in this.sections[indices[0]])
        return true
      })
    },

    markItemAsRemoved (oldValue, ...indices) {
      const key = this.getItemKey(indices)
      this.itemsMarkedAsRemoved[key] = true
      this.labelsMarkedAsRemoved[key] = oldValue
    },

    undoRemovedItem (...indices) {
      const key = this.getItemKey(indices)
      this.itemsMarkedAsRemoved[key] = false
      return this.labelsMarkedAsRemoved[key]
    },

    undoDelete (secIndex, lineIndex, optIndex) {
      if (lineIndex !== undefined) {
        const oldLabel = this.undoRemovedItem(secIndex, lineIndex)
        this.updateLabelForLine(secIndex, lineIndex, oldLabel)
        return
      }
      const oldLabel = this.undoRemovedItem(secIndex)
      this.updateLabelForSection(secIndex, oldLabel)
      this.$forceUpdate()
    },

    addSection (forReference = false, secIndex) {
      const newItem = {}
      newItem.title = ''
      newItem.forReference = forReference
      newItem.lineItems = [this.initLineItem(1)]
      if (this.isAddendum) {
        newItem.addendumLabel = addendumChangeType.pending.added
        newItem.lineItems[0].addendumLabel = addendumChangeType.pending.added
      }

      let newValue = Object.assign([], this.sections)
      if (forReference) {
        newItem.checked = false
        newItem.title = this.$t('tender.section.forReference')
        newItem.sectionDesc = this.$t('tender.section.forReferenceDesc')
        newValue.push(newItem)
      } else {
        const startIndex = lodash.isUndefined(secIndex) ? -1 : (secIndex + 1)
        newValue.splice(startIndex, 0, newItem)
      }
      const path = [this.serviceStr]
      this.updateSection({ path, newValue })
    },

    addSectionDesc (item, index) {
      const path = this.getSectionFieldPath(index, null)
      item.sectionDesc = ''
      if (this.isAddendum && item.addendumLabel !== addendumChangeType.pending.added) {
        item.addendumLabel = addendumChangeType.pending.updated
      }
      this.updateSection({ path, newValue: item })
    },

    deleteSection (item, index) {
      if (this.isAddendum && item.addendumLabel !== addendumChangeType.pending.added) {
        // no physical delete
        this.markItemAsRemoved(this.sections[index].addendumLabel, index)
        this.updateLabelForSection(index, addendumChangeType.pending.removed)
        this.$forceUpdate()
        return
      }

      let newValue = []
      newValue = Object.assign([], this.sections)
      if (index === 0 && this.sections.length === 2) {
        const section = {}
        section.title = ''
        section.forReference = false
        section.lineItems = [this.initLineItem(1)]
        newValue.splice(index, 1, section)
      } else {
        newValue.splice(index, 1)
      }

      const path = [this.serviceStr]
      this.updateSection({ path, newValue })
    },

    addLine (secIndex, lineIndex) {
      const section = this.getSectionByIndex(secIndex)

      if (this.isAddendum) {
        const addendumLineIndex = (section.lineItems || []).length || 0
        const addendumLineItem = this.initLineItem(addendumLineIndex + 1)

        addendumLineItem.addendumLabel = addendumChangeType.pending.added

        const path = this.getLineItemFieldPath(secIndex, addendumLineIndex)
        this.updateSection({ path, newValue: addendumLineItem })
      } else {
        const lineItems = section.lineItems
        const lineItem = this.initLineItem(lineIndex + 2)

        lineItems.splice(lineIndex + 1, 0, lineItem)
        const newValue = this.refreshLineItemSeq(lineItems)
        const path = this.getLineItemFieldPath(secIndex, null)
        this.updateSection({ path, newValue })
      }
    },

    refreshLineItemSeq (lineItems) {
      const newItems = lineItems
      for (let i = 0; i < lineItems.length; i += 1) {
        if (lineItems[i].itemNo !== (i + 1)) {
          newItems[i].itemNo = i + 1
        }
      }
      return newItems
    },

    deleteLine (item, secIndex, lineIndex) {
      if (this.isAddendum && item.addendumLabel !== addendumChangeType.pending.added) {
        const line = this.getLineItemByIndex(secIndex, lineIndex)
        this.markItemAsRemoved(line.addendumLabel, secIndex, lineIndex)
        this.updateLabelForLine(secIndex, lineIndex, addendumChangeType.pending.removed)
        return
      }

      const updatedSection = this.getSectionByIndex(secIndex)
      const lineItems = updatedSection.lineItems

      if (lineIndex > -1) {
        lineItems.splice(lineIndex, 1)
      }

      if (lineItems.length === 0) {
        lineItems.push(this.initLineItem())
      }

      const newValue = this.refreshLineItemSeq(lineItems)
      const path = this.getLineItemFieldPath(secIndex, null)
      this.updateSection({ path, newValue })
    },

    addendumToggleSecForRef (section, secIndex, fieldName, newValue) {
      if (newValue && [addendumChangeType.pending.removed, addendumChangeType.removed].includes(section.addendumLabel)) {
        this.undoDelete(secIndex)
      } else if (!newValue) {
        this.deleteSection(section, secIndex)
      }
      this.onOptionalChange(secIndex, fieldName, newValue)
    },

    initLineItem (itemNo) {
      const emptyLine = {}
      emptyLine.itemNo = itemNo
      emptyLine.itemDesc = ''
      emptyLine.itemQty = null
      emptyLine.itemUnit = this.defaultUnit
      return emptyLine
    },

    validate () {
      this.form = $('#items-services-edit-form')
      this.form.on('submit', (ev) => {
        ev.preventDefault()
      })
      this.abide = new Foundation.Abide(this.form, {
        liveValidate: false,
      })
      this.abide.validateForm()
      fusionInputCheckUtil.validateAllFields('.edit-itemServices')
      return $('#items-services-edit-form input.is-invalid-input').length !== 0 ||
        $('#items-services-edit-form textarea.is-invalid-input').length !== 0 ||
        !fusionInputCheckUtil.isAllFieldsValid('#items-services-edit-form')
    },

    clearErrorClasses () {
      fusionInputCheckUtil.resetAllFields()
      if ($('#items-services-edit-form .is-invalid-input').length > 0 && this.abide) {
        this.abide.removeErrorClasses($('#items-services-edit-form .is-invalid-input'))
      }
    },

    highlightDeleteChange (...updatedLabels) {
      if (!this.isAddendum) return ''
      const matched = updatedLabels.filter(label => label && label.includes(addendumChangeType.removed))
      return matched.length > 0 ? `${this.addendumClassName}-${addendumChangeType.removed}` : ''
    },
    disableActions (action, ...updatedLabels) {
      if (!this.isAddendum) return ''
      if (['undoDeleteLine', 'undoDeleteOption'].includes(action)) return 'none-text-decoration'
      const matched = updatedLabels.filter(label => label && label.includes(addendumChangeType.removed))
      return matched.length > 0 ? 'disabled-link' : ''
    },
    highlightDeleteActions (action, addendumLabel) {
      if (['addSection', 'addSectionDesc', 'addLine'].includes(action)) {
        const hightlight = this.highlightDeleteChange(addendumLabel)
        return hightlight ? hightlight + ' ' + 'disabled-link' : ''
      }
    },

    disabledDeletedItem (...updatedLabels) {
      if (!this.isAddendum) return false
      let disabled = false
      updatedLabels.forEach((updatedLabel) => {
        if (updatedLabel && updatedLabel.includes(addendumChangeType.removed)) {
          disabled = true
        }
      })
      return disabled
    },
    onRowPaste (pasteEvent, section, secIndex) {
      const isRemovedItem = item => [
        addendumChangeType.pending.removed,
        addendumChangeType.removed,
      ].includes(item && item.addendumLabel)
      const isNewItem = item => [
        addendumChangeType.pending.added,
      ].includes(item && item.addendumLabel)

      mergePasteData({
        pasteEvent,
        currentData: section.lineItems,
        columnKeys: ['itemDesc', 'itemQty', 'itemUnit'],
        commonInfo: {
          itemUnit: this.defaultUnit,
        },
        hooks: {
          itemDesc: (value, oldValue, originalItem) => {
            return isRemovedItem(originalItem) ? oldValue : value
          },
          itemUnit: (value, oldValue, originalItem) => {
            if (isRemovedItem(originalItem)) return oldValue

            const unitIndex = this.units.findIndex(
              unit => unit.toLowerCase() === (value + '').toLowerCase(),
            )
            if (unitIndex > -1) return this.units[unitIndex]
            return oldValue || this.defaultUnit
          },
          itemQty: (value, oldValue, originalItem) => {
            if (isRemovedItem(originalItem)) return oldValue

            if (typeof value === 'string') {
              value = value.replace(nonNumericCharsInCurrency, '')
            }
            return (+value) > 0 ? (+value) : oldValue
          },
          addendumLabel: (value, oldValue, originalItem) => {
            if (isRemovedItem(originalItem)) return oldValue

            if (this.isAddendum) {
              if (!originalItem) return addendumChangeType.pending.added
              if (!isNewItem(originalItem)) return addendumChangeType.pending.updated
              return oldValue
            } else {
              return undefined
            }
          },
        },
        callback: (data) => {
          this.updateSection({
            path: this.getLineItemFieldPath(secIndex, null),
            newValue: this.refreshLineItemSeq(data),
          })
        },
      })
    },
    addSectionAsNeed () {
      if (!this.sections || this.sections.length === 0) {
        this.addSection(false)
      }
      if (!this.lockItems && !this.sections[this.sections.length - 1].forReference) {
        this.addSection(true)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/settings';
@import '~styles/tender/edit';
@import '~styles/tender/addendum';
@import '~styles/popup';

$grey-color: #e0e0e0;
$font-color: #5f7988;

.section-border-hr {
  border: solid 1px #e0e0e0;
  margin: 0 0 20px 0;
}

.title {
  font-family: Verdana;
  font-size: 24px;
  text-align: left;
  color: #0c3a58;
}

.description {
  text-align: left;
  color: #0c3a58;
}

input, textarea {
  margin-bottom: 8px;
  font-size: 14px;
  border: solid 1px #B5B5B5;
}

textarea[disabled], input[disabled] {
  border: solid 1px #e5e5e5;
  background: transparent;
}

table, thead, tbody, tr, td {
  border: none;
  padding: 0 8px 0 0;
  vertical-align: top;
  background-color: transparent;
  color: $font-color;
}
tbody tr:nth-child(even) {
  background-color: transparent;
}
.row {
  margin-left: 0;
}
.input-group {
  display: table-row !important;
}
.desc-work {
  width: 97%;
  height: 40;
  margin-top: 0;
  margin-right: 0;
  background-color: #ffffff;
  &.is-invalid-input {
    background-color: #f9ecea;
  }
}
.select-unit {
  width: 100px;
  background-color: #ffffff;
  border: solid 1px $font-color;
}

.select-tag {
  font-size: medium;
}

.number {
  width: 35px;
  padding-left: 0;
  vertical-align: top;
  text-align: left;
  color: $tender-font-color;
}

input.is-invalid-input {
  background-color: #f9ecea!important;
}

.confirm-header {
  margin-bottom: 0;
  font-size: 14px;
}

.section-optional-items-checkbox {
  margin: 10px 10px 0 0;
}
@import '~styles/tender/addendum';
</style>

<style lang="scss">
#edit-itemServices {

  td[id^="line.unit_"] {
    .hkl-select {
      max-width: 170px;
    }
  }

  .disabled-link {
    pointer-events: none;
  }
  .none-text-decoration {
    &, a {
      text-decoration: none !important;
    }
  }
}
</style>
